import React from "react";
import {
  Card,
  CardBody,
  CircularProgress,
  CircularProgressLabel,
} from "@chakra-ui/react";
import { haptic } from "@/lib/haptic";

interface HighlightCardProps {
  title: JSX.Element;
  subtitle: JSX.Element;
  variant: "blue" | "green";
  progressVal: number;
  progressStyle?: React.CSSProperties;
  icon: JSX.Element;
  onClick: () => void;
}

const HighlightCard: React.FC<HighlightCardProps> = ({
  title,
  subtitle,
  variant,
  progressVal,
  progressStyle,
  icon,
  onClick,
}) => {
  const handleClick = () => {
    haptic.light();
    onClick();
  };
  return (
    <Card className="w-full h-auto" variant={variant} onClick={handleClick}>
      <CardBody className="flex flex-col items-start text-start gap-3 p-3">
        <div className="flex flex-row w-full justify-between">
          <div className="text-xl font-normal w-3/4 pr-2">{title}</div>
          <div className="self-end">
            <CircularProgress
              value={progressVal}
              size="75px"
              thickness="9px"
              color="white"
              trackColor="var(--color-blue)"
              style={{
                ...progressStyle,
                cursor: variant == "green" ? "pointer" : "default",
              }}
              onClick={onClick}
              className={
                variant == "green" ? "hover:opacity-80 transition-opacity" : ""
              }
            >
              <CircularProgressLabel>
                <div className="flex items-center justify-center">{icon}</div>
              </CircularProgressLabel>
            </CircularProgress>
          </div>
        </div>
        <div className="text-sm mt-3">{subtitle}</div>
      </CardBody>
    </Card>
  );
};

export default HighlightCard;
